//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _profile from './profile';
export const profile = _profile;
export default {profile};

